import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter, ConfirmModal, CommonServices } from 'src/modules/shared';
import { FAQModal } from '../../modals';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FaqService } from '../../services';
import {
  NewEquipmentModal,
  EditEquipmentModal,
} from 'src/modules/features/contractor/modals';

@Component({
  selector: 'app-company-equipment',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FAQComponent implements OnInit {
  FAQs = [];
  projectId: string;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'question',
        op: 'cn',
        data: '',
      },
      {
        field: 'answer',
        op: 'cn',
        data: '',
      },
    ],
  };
  equipmentTypes: Array<any> = [];
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private faqSvc: FaqService,
    private commonSvc: CommonServices
  ) {
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    this.getPage(1);
  }

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.faqSvc
      .getFaqs({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.FAQs = res['rows'];
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  delete(event: any): void {
    this.pending = true;
    this.error = null;
    this.faqSvc.removeFaq({ FaqId: event.faqId }).subscribe(
      (res) => {
        this.pending = false;
        this.success = 'FAQ removed successfully';
        this.getPage(this.filter.page);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove FAQ?',
          'Are you sure you want to remove faq?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.delete(event);
      })
      .onDeny(() => {});
  }

  addFAQ() {
    this.modalService
      .open(
        new FAQModal(
          'New FAQ',
          'Are you sure you want to delete this Lot plan?',
          false,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }

  editFAQ(equipment) {
    this.modalService
      .open(new FAQModal('Edit FAQs', equipment, true, ModalSize.Tiny))
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'AND',
      rules: [
        {
          field: 'optionName',
          op: 'cn',
          data: '',
        },
        // {
        //   field: 'answer',
        //   op: 'cn',
        //   data: '',
        // },
      ],
    };
    searchFilter.rules[0].data = search;
    // searchFilter.rules[1].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  ngOnInit(): void {}
}
